var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDocumentPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9938_16981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.78394 18V21H20.1839V8.4L14.7839 3H5.78394V11.0065H7.58394V4.8H13.8839V9.3H18.3839V19.2H7.58394V18H5.78394Z",
    fill: "#7B8389"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10187 14.272H6.65114V13.3628H7.10187C7.21739 13.3628 7.30327 13.4013 7.35936 13.4781C7.41879 13.5507 7.44857 13.6552 7.44857 13.7918V13.843C7.44857 13.9754 7.41879 14.08 7.35936 14.1568C7.30327 14.2336 7.21739 14.272 7.10187 14.272Z",
    fill: "#7B8389"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2255 15.6678H10.587C11.046 15.6678 11.2755 15.3498 11.2755 14.7138V14.3297C11.2755 13.6937 11.046 13.3757 10.587 13.3757H10.2255V15.6678Z",
    fill: "#7B8389"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1582 10.9521H4V18.0372H17.1582V10.9521ZM8.03299 12.5113C7.86792 12.3833 7.67974 12.3192 7.46834 12.3192H5.55656V16.7242H6.65114V15.3029H7.46834C7.67974 15.3029 7.86792 15.241 8.03299 15.1172C8.19806 14.9891 8.3268 14.8141 8.41935 14.5922C8.51177 14.3702 8.55798 14.1226 8.55798 13.8495V13.7662C8.55798 13.493 8.51177 13.2476 8.41935 13.0299C8.3268 12.808 8.19806 12.6351 8.03299 12.5113ZM10.6069 12.3192C11.7988 12.3192 12.3949 13.0534 12.3949 14.5217C12.3949 15.9901 11.7988 16.7242 10.6069 16.7242H9.1309V12.3192H10.6069ZM12.9858 12.3192H15.7397V13.3757H14.0804V14.1312H15.5068V15.1428H14.0804V16.7242H12.9858V12.3192Z",
    fill: "#7B8389"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9938_16981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocumentPdf);
export default __webpack_public_path__ + "static/media/icon_document_pdf.10a4cba29b57654ee6be22f0f777226d.svg";
export { ForwardRef as ReactComponent };